import AlertCenter from './src/alert-center/index';


export { AlertCenter };
